(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const header = document.querySelector('.header--overlay');
  if (!header) return;
  const panel = header.querySelector('[data-search-panel]');
  const update = () => {
    const solid = window.scrollY > 40 || header.matches(':hover, :focus-within') || (panel && !panel.hidden);
    header.classList.toggle('is-solid', solid);
  };
  window.addEventListener('scroll', update, { passive: true });
  header.addEventListener('mouseenter', update);
  header.addEventListener('mouseleave', update);
  header.addEventListener('focusin', update);
  header.addEventListener('focusout', () => setTimeout(update, 0));
  header.addEventListener('click', () => setTimeout(update, 0));
  update();

  // El tono del encabezado sigue a la slide visible del carrusel (texto oscuro = fondo claro).
  const hero = document.querySelector('[data-slideshow]');
  if (hero) {
    const tone = () => {
      const active = hero.querySelector('.slide[aria-hidden="false"]');
      header.classList.toggle('is-on-light', !!active && active.classList.contains('slide--text-dark'));
    };
    new MutationObserver(tone).observe(hero, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
    tone();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Solo se descarga el video que se ve (escritorio o móvil).
  document.querySelectorAll('[data-vhero] video').forEach((video) => {
    if (getComputedStyle(video).display !== 'none') return;
    video.pause();
    video.removeAttribute('autoplay');
    video.preload = 'none';
    video.querySelectorAll('source').forEach((source) => source.remove());
    video.load();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playstyle-selector"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-pstyle]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = root.querySelector('#' + t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        select(next);
        next.focus();
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-slideshow]').forEach((root) => {
    const track = root.querySelector('[data-slideshow-track]');
    const slides = [...root.querySelectorAll('[data-slide]')];
    const dots = [...root.querySelectorAll('[data-slideshow-dot]')];
    const pauseBtn = root.querySelector('[data-slideshow-pause]');
    if (!track || slides.length < 2) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval = Math.max(3, Number(root.dataset.interval || 6)) * 1000;
    let index = 0;
    let timer = null;
    let userPaused = reduced || root.dataset.autoplay !== 'true';
    let hover = false;

    const goTo = (i) => {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(${-index * 100}%)`;
      dots.forEach((d, n) => {
        d.classList.toggle('is-active', n === index);
        if (n === index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      slides.forEach((s, n) => {
        s.toggleAttribute('inert', n !== index);
        s.setAttribute('aria-hidden', n === index ? 'false' : 'true');
      });
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (userPaused || hover || document.hidden) return;
      timer = setInterval(() => goTo(index + 1), interval);
    };

    dots.forEach((d) => d.addEventListener('click', () => { goTo(Number(d.dataset.slideshowDot)); start(); }));
    root.querySelector('[data-slideshow-prev]')?.addEventListener('click', () => { goTo(index - 1); start(); });
    root.querySelector('[data-slideshow-next]')?.addEventListener('click', () => { goTo(index + 1); start(); });
    pauseBtn?.addEventListener('click', () => {
      userPaused = !userPaused;
      root.classList.toggle('is-paused', userPaused);
      pauseBtn.setAttribute('aria-label', userPaused ? 'Reproducir' : 'Pausar');
      start();
    });
    root.addEventListener('mouseenter', () => { hover = true; stop(); });
    root.addEventListener('mouseleave', () => { hover = false; start(); });
    root.addEventListener('focusin', () => { hover = true; stop(); });
    root.addEventListener('focusout', () => { hover = false; start(); });
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { goTo(index + 1); }
      if (e.key === 'ArrowLeft') { goTo(index - 1); }
    });
    document.addEventListener('visibilitychange', start);

    // Deslizar con el dedo o el mouse
    let startX = 0;
    let deltaX = 0;
    let dragging = false;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; startX = e.clientX; deltaX = 0; stop();
    });
    window.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      deltaX = e.clientX - startX;
      if (Math.abs(deltaX) > 6) {
        track.classList.add('is-dragging');
        track.style.transform = `translateX(calc(${-index * 100}% + ${deltaX}px))`;
      }
    });
    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (Math.abs(deltaX) > 50) goTo(index + (deltaX < 0 ? 1 : -1)); else goTo(index);
      start();
    };
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', (e) => { if (Math.abs(deltaX) > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', (e) => e.preventDefault());

    if (userPaused) root.classList.add('is-paused');
    goTo(0);
    start();

    // Editor de temas: mostrar la diapositiva seleccionada
    document.addEventListener('shopify:block:select', (e) => {
      const i = slides.findIndex((s) => s.contains(e.target));
      if (i > -1) { hover = true; stop(); goTo(i); }
    });
    document.addEventListener('shopify:block:deselect', () => { hover = false; start(); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
